import { ResultTableWidgetConfiguration } from './ResultTableWidget.types'

export default function (config: ResultTableWidgetConfiguration) {
    return {
        rowOffset: 0,
        orderBy: config.orderBy,
    }
}
